import { mutableValuePlaceholder, } from '@polestar/component-warehouse-react/hooks/useMutableValue';
import React, { createContext, useContext, useState, useEffect } from 'react';
/**
 * @internal
 */
export const DrawerContext = createContext({
    /**
     * @internal
     */
    translateOffsetLeft: mutableValuePlaceholder(0),
});
/**
 * @internal
 */
export const useDrawerTranslateOffset = () => {
    const { translateOffsetLeft: drawerTranslateOffsetLeft } = useContext(DrawerContext);
    const [translateOffsetLeft, setTranslateOffsetLeft] = useState(drawerTranslateOffsetLeft.get());
    useEffect(() => drawerTranslateOffsetLeft.on('change', setTranslateOffsetLeft), [drawerTranslateOffsetLeft]);
    return { translateOffsetLeft };
};
/**
 * @internal
 */
export const DrawerProvider = ({ children, translateOffsetLeft }) => (React.createElement(DrawerContext.Provider, { value: {
        translateOffsetLeft,
    } }, children));
